var products = {
  "E100071B_09A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_2f0f27c8-a793-41d0-93cd-3ed3574e51f9.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "E100071B_71C Blue Purple": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E100071B_Burgundy": {
    items: [
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_fa265dc6-272e-42d0-bf1f-8d427bc275b0.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      }
    ]
  },
  "E100071B_Printed": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-stretchy-running-leggings-womens-high-support-leggings-58a-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_4dcd291e-7478-4b3d-9fd8-ec345428407e.jpg",
        title: "Power High Waist Mesh Pockets Stretchy Running Leggings",
        a: "$19.00"
      }
    ]
  },
  "E100085A_00A White": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100085A_06H Grey": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_340fa1d7-c296-46a6-a2f6-27461033494b.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100085A_08A Dark Grey": {
    items: [
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$34.90"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100085A_09A Black": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100085A_13A Rose": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      }
    ]
  },
  "E100085A_18A Wine": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100323A01_00A White": {
    items: [
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100323A01_09A Black": {
    items: [
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_46cdb7d8-7b15-41f4-b4db-9697a6a52111.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100323A01_26F Orange Red": {
    items: [
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_46cdb7d8-7b15-41f4-b4db-9697a6a52111.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100323A01_63A Sky Blue": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-stretchy-full-length-leggings-womens-high-support-full-length-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_635d234a-2c46-4d59-84ed-921f4e1dd11a.jpg",
        title: "Anywhere Soft Stretchy Full-length leggings 26",
        a: "$35.00"
      },
      {
        url: "/products/shift-light-jacquard-cutout-yoga-t-shirt-womens-long-sleeve-t-shirt-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_c82b0a51-83de-44eb-90ef-f506485f9837.jpg",
        title: "Shift Light Jacquard Cutout Yoga T-shirt",
        a: "$35.00"
      }
    ]
  },
  "E100323A01_65K Royal Blue": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_de47f25e-5412-4048-a268-2155f06a245d.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$68.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100325A01_00A White": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_de47f25e-5412-4048-a268-2155f06a245d.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$68.00"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-blue1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_45e31b66-2863-4752-8178-7fd65ba420d7.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$68.00"
      }
    ]
  },
  "E100325A01_11AK Pink": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100357A08_00A White": {
    items: [
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-black-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1f0ec0b4-7ab5-4251-b471-1204b355b4c8.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E100357A08_09A Black": {
    items: [
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-black-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1f0ec0b4-7ab5-4251-b471-1204b355b4c8.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E100392A03_08A Dark Grey": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_2f0f27c8-a793-41d0-93cd-3ed3574e51f9.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waist-perforated-zip-pocket-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_66313a0e-1344-4152-ae5c-fa70f120b29f.jpg",
        title: "Echo High-Waist Perforated Zip Pocket Biker Shorts",
        a: "$38.00"
      }
    ]
  },
  "E100392A03_09A Black": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-black-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1f0ec0b4-7ab5-4251-b471-1204b355b4c8.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
       {
        url: "/products/echo-high-waist-perforated-zip-pocket-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_66313a0e-1344-4152-ae5c-fa70f120b29f.jpg",
        title: "Echo High-Waist Perforated Zip Pocket Biker Shorts",
        a: "$38.00"
      }
    ]
  },
  "E100501A19_08A Dark Grey": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E100501A19_09A Black": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E100501A19_70A Light Purple": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E100556A19_00A White": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100556A19_08A Dark Grey": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waist-pockets-side-perforated-biker-shorts-womens-high-support-sports-shorts-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_ff9874a1-fa85-4496-9234-8a7a91937df3.jpg",
        title: "Echo High Waist Pockets Side Perforated Biker Shorts 8",
        a: "$39.00"
      }
    ]
  },
  "E100556A19_09A Black": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100556A19_71F Light Blue Purple": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100556A19_13A Rose": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100556A19_50J Light Green": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },


  
  "E100666A08_00A White": {
    items: [
       {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/power-cross-racerback-running-bra-womens-high-support-sports-bra-3-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_6c0ad9aa-94bd-4032-8acd-788858335086.jpg",
        title: "Power Cross Racerback Running Bra",
        a: "$34.00"
      }
    ]
  },
  "E100666A08_07R Grey": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100666A08_09A Black": {
    items: [
       {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-mesh-pockets-tennis-skirt-womens-sports-skirt-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cf25a317-501a-4ea4-ae06-2914876d36c4.jpg",
        title: "Sculpt Mesh Pockets Tennis Skirt",
        a: "$44.00"
      }
    ]
  },
  "E100666A08_10AJ Pink": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_3ae382ed-2bcb-4393-bf4d-11406974675e.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      }
    ]
  },
  "E100666A08_18F Wine": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/women-high-waisted-perforated-running-leggings-35i-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_ccc833bd-97a4-4ba7-9c18-c438cc8339e7.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      }
    ]
  },
  "E100666A08_64T Blue": {
    items: [
       {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_6435bf88-4dcb-48b7-830a-bf0820a068bf.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      },
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5fee4e85-7b1b-4d05-b479-eae808b4b3fe.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E100666A08_70B Light Purple": {
    items: [
       {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },

  
  "E100755A19_09A Black": {
    items: [
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100755A19_41A Yellow": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100755A19_73F Purple": {
    items: [
       {
        url: "/products/echo-stretchy-solid-capri-leggings-womens-high-support-capri-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a20f8515-b91c-4f61-85d2-19cf46e3c266.jpg",
        title: "Anywhere Stretchy Streamlined leggings 21",
        a: "$29.00"
      },
       {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },

  
  "E110361A19_09A Black": {
    items: [
       {
        url: "/products/shift-racerback-mesh-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2ddb3973-a53d-4c6e-b248-a17c9a0dbadb.jpg",
        title: "Shift Racerback Mesh Padded Running Bra",
        a: "$28.00"
      },
       {
        url: "/products/power-cross-back-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_870c73f7-925e-4b68-8a04-011afcd6aee3.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      }
    ]
  },
  "E110361A19_76A Purple": {
    items: [
       {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c3b2fdb7-fb9f-423e-ab86-522a3cc6a1fc.jpg",
        title: "Shift Scoop Neckline Strappy Padded Yoga Bra",
        a: "$29.00"
      },
       {
        url: "/products/power-cross-back-padded-running-bra-blue-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8ebd4995-7df2-4557-a8f4-672e3f89daec.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
       {
        url: "/products/power-adjustable-running-bra-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033111449.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      }
    ]
  },

  
  "E110390A06_05D Medium Grey": {
    items: [
       {
        url: "/products/power-classic-zip-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112994.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
       {
        url: "/products/power-cross-back-padded-running-bra-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9bb23321-cc16-4c0c-b8e1-1fd51e7755cd.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
       {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f8c6ea5c-21b8-41b6-bd0d-d2778df5fa44.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$34.00"
      }
    ]
  },
  "E110390A06_09A Black": {
    items: [
       {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$29.00"
      },
       {
        url: "/products/power-cross-back-padded-running-bra-olive",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c0d77506-0018-4259-865d-2f748fc2adca.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      }
    ]
  },
  "E110390A06_69A Dark Blue": {
    items: [
       {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-navy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_3a127b95-d2ed-41a4-99ec-401046be4b6b.jpg",
        title: "Enfold Zip Front Mesh Racerback Padded Running Bra",
        a: "$29.00"
      },
       {
        url: "/products/shift-racerback-mesh-padded-running-bra-womens-high-support-sports-bra-navy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_c469f158-5653-4000-883f-6e815f6f9ca9.jpg",
        title: "Shift Racerback Mesh Padded Running Bra",
        a: "$32.00"
      },
       {
        url: "/products/power-classic-zip-running-bra-blue-tide",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033111905.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      }
    ]
  },

  
  "H0100003_00A White": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_7a2e89b8-374d-4b00-8726-e52c0c240791.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e306e052-019b-4260-83d1-098439ddf474.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0100003_08A Dark Grey": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "H0100003_10B Light Pink": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e306e052-019b-4260-83d1-098439ddf474.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_2f0f27c8-a793-41d0-93cd-3ed3574e51f9.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0100003_11M Pink": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_7a2e89b8-374d-4b00-8726-e52c0c240791.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "H0100003_13A Rose": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
        {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e306e052-019b-4260-83d1-098439ddf474.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0100003_26B Orange Red": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_46cdb7d8-7b15-41f4-b4db-9697a6a52111.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e306e052-019b-4260-83d1-098439ddf474.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0100003_42A Light Yellow": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5fee4e85-7b1b-4d05-b479-eae808b4b3fe.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e306e052-019b-4260-83d1-098439ddf474.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0100003_51D Green": {
    items: [
       {
        url: "/products/echo-high-waist-perforated-zip-pocket-biker-shorts-womens-high-support-sports-shorts-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_-2_8748fdf2-6bfb-40c6-87d1-e3c11eb2748b.jpg",
        title: "Echo High-Waist Perforated Zip Pocket Biker Shorts",
        a: "$38.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5fee4e85-7b1b-4d05-b479-eae808b4b3fe.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "H0100003_53C Grass Green": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-fitted-mock-neck-t-shirt-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0e13f1dd-d454-4f49-8216-2b37f6b2a12d.jpg",
        title: "Shift Fitted Mock Neck T-shirt",
        a: "$49.00"
      },
      {
        url: "/products/shift-light-jacquard-cutout-yoga-t-shirt-womens-long-sleeve-t-shirt-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_c82b0a51-83de-44eb-90ef-f506485f9837.jpg",
        title: "Shift Light Jacquard Cutout Yoga T-shirt",
        a: "$35.00"
      }
    ]
  },
  "H0100003_57A Olive": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e306e052-019b-4260-83d1-098439ddf474.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_7a2e89b8-374d-4b00-8726-e52c0c240791.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "H0100003_66Ptk Blue Print": {
    items: [
       {
        url: "/products/echo-stretchy-full-length-leggings-womens-high-support-full-length-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_635d234a-2c46-4d59-84ed-921f4e1dd11a.jpg",
        title: "Anywhere Soft Stretchy Full-length leggings 26",
        a: "$35.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5fee4e85-7b1b-4d05-b479-eae808b4b3fe.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "H0100003_71C Blue Purple": {
    items: [
       {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      },
      {
        url: "/products/shift-fitted-mock-neck-t-shirt-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_3857b806-dd6f-466a-bc99-786967bda4a4.jpg",
        title: "Shift Fitted Mock Neck T-shirt",
        a: "$49.00"
      },
       {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c3b2fdb7-fb9f-423e-ab86-522a3cc6a1fc.jpg",
        title: "Shift Scoop Neckline Strappy Padded Yoga Bra",
        a: "$29.00"
      }
    ]
  },
  "H0100003_Black": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "H0100003_Blue": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5fee4e85-7b1b-4d05-b479-eae808b4b3fe.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-mesh-yoga-leggings-royal-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ddc1d8a1-f1cc-4564-964d-337d208084e1.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-stretchy-full-length-leggings-womens-high-support-full-length-leggings-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_635d234a-2c46-4d59-84ed-921f4e1dd11a.jpg",
        title: "Anywhere Soft Stretchy Full-length leggings 26",
        a: "$35.00"
      }
    ]
  },
  "H0100003_Burgundy": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_fa265dc6-272e-42d0-bf1f-8d427bc275b0.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },


  
  "H0600006_11B Dark Pink": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "H0600006_57A Olive": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "H0600006_70A Light Purple": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "H0600006_Black": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "H0600006_Dark Grey": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "H0600006_Grey": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "H0600006_Light Purple": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  

  "H0800003_00A White": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0800003_08A Dark Grey": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0800003_09A Black": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },
  "H0800003_69A Navy": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      }
    ]
  },

  
  "HM0066085_00A White": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      },
       {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_7931bf4a-61a1-4fa6-b847-99b789ad48c2.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      }
    ]
  },
  "HM0066085_09A Black": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      },
       {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_7931bf4a-61a1-4fa6-b847-99b789ad48c2.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0066085_17A Burgundy": {
    items: [
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      },
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "HM0066085_75A Purple": {
    items: [
       {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_849b8b85-4aae-4e8f-92ba-6e7fad3d9d4c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      }
    ]
  },

  
  "HM0130001_00A White": {
    items: [
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0130001_00PTW White Print": {
    items: [
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0130001_07PTF Caesious Print": {
    items: [
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0130001_09A Black": {
    items: [
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0130001_66PTI Blue Print": {
    items: [
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0130001_Nude-Black": {
    items: [
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0130001_White-Black": {
    items: [
       {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$39.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },

  
  "S100731A06_00A White": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100731A06_04A Grey": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100731A06_09A Black": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100731A06_23100 Black": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100731A06_26088 Blue": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100731A06_28103 Red": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100731A06_38D Dark Brown": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100731A06_61B Blue": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  
  "S100745A06_00A White": {
    items: [
       {
        url: "/products/enfold-high-waist-pockets-stretchy-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_71ede721-834b-490b-891b-30ebaa80085c.jpg",
        title: "Enfold High Waist Pockets Stretchy Running Leggings 26",
        a: "$49.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100745A06_09A Black": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/sculpt-mesh-pockets-tennis-skirt-womens-sports-skirt-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cf25a317-501a-4ea4-ae06-2914876d36c4.jpg",
        title: "Sculpt Mesh Pockets Tennis Skirt",
        a: "$44.00"
      }
    ]
  },
  "S100745A06_11C Pink": {
    items: [
       {
        url: "/products/enfold-high-waist-pockets-stretchy-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_71ede721-834b-490b-891b-30ebaa80085c.jpg",
        title: "Enfold High Waist Pockets Stretchy Running Leggings 26",
        a: "$49.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_ef430b94-d247-463d-8883-ba90b5ef2221.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100745A06_42A Light Yellow": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/enfold-high-waist-pockets-stretchy-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_71ede721-834b-490b-891b-30ebaa80085c.jpg",
        title: "Enfold High Waist Pockets Stretchy Running Leggings 26",
        a: "$49.00"
      }
    ]
  },
  "S100745A06_75A Purple": {
    items: [
       {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },

  
  "140605A08_19I Wine": {
    items: [
       {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_aae1a6d4-d4a6-43e3-b366-40737f56ac59.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Four-way Stretch Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "140605A08_78B Purple": {
    items: [
       {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_aae1a6d4-d4a6-43e3-b366-40737f56ac59.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Four-way Stretch Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "140605A08_37E Brown": {
    items: [
       {
        url: "/products/anywhere-pockets-slim-fit-track-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_54554b6f-c7ea-4d32-895d-100dcb97011b.jpg",
        title: "Anywhere Pockets Slim Fit Track Pants",
        a: "$41.90"
      },
      {
        url: "/products/shift-letter-print-fleece-lined-wide-leg-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_933c4175-ec20-4e9e-b67d-28da352d8ac1.jpg",
        title: "Shift Letter Print Fleece Lined Wide Leg Pants 27",
        a: "$41.90"
      }
    ]
  },
  "140605A08_05D Gray": {
    items: [
       {
        url: "/products/anywhere-pockets-slim-fit-track-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_54554b6f-c7ea-4d32-895d-100dcb97011b.jpg",
        title: "Anywhere Pockets Slim Fit Track Pants",
        a: "$41.90"
      },
      {
        url: "/products/shift-letter-print-fleece-lined-wide-leg-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_933c4175-ec20-4e9e-b67d-28da352d8ac1.jpg",
        title: "Shift Letter Print Fleece Lined Wide Leg Pants 27",
        a: "$41.90"
      }
    ]
  },
  "140605A08_09A Black": {
    items: [
       {
        url: "/products/anywhere-pockets-slim-fit-track-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_54554b6f-c7ea-4d32-895d-100dcb97011b.jpg",
        title: "Anywhere Pockets Slim Fit Track Pants",
        a: "$41.90"
      },
      {
        url: "/products/shift-letter-print-fleece-lined-wide-leg-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_933c4175-ec20-4e9e-b67d-28da352d8ac1.jpg",
        title: "Shift Letter Print Fleece Lined Wide Leg Pants 27",
        a: "$41.90"
      }
    ]
  },
  "150557A08AS_09A Black": {
    items: [
       {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/anywhere-irregular-hem-fitted-short-yoga-tank-womens-sports-tank-black",
        imageUrl: "/products/anywhere-irregular-hem-fitted-short-yoga-tank-womens-sports-tank-black",
        title: "Anywhere Irregular Hem Fitted Short Yoga Tank",
        a: "$35.90"
      }
    ]
  },
  "E110687A08AS-1_09A Black": {
    items: [
       {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/shift-fleece-water-resistant-stretchy-full-zip-jacket-womens-sports-jacket-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1eb0684a-935b-459f-a695-17eb945575b0.jpg",
        title: "Shift Fleece Water Resistant Stretchy Full Zip Jacket",
        a: "$46.90"
      },
      {
        url: "/products/shift-fleece-slim-fit-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_92db3082-c565-4b36-a1b7-7010a5448a93.jpg",
        title: "Shift Fleece Light Stretchy Full Zip Jacket",
        a: "$43.90"
      }
    ]
  },
  "140605A08_17A Red": {
    items: [
       {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Four-way Stretch Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "140605A08_37E Brown": {
    items: [
       {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Four-way Stretch Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S110438A08_35C Light Brown": {
    items: [
       {
        url: "/products/shift-soft-stretchy-solid-color-long-sleeve-t-shirt-womens-long-sleeve-t-shirt-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_65195a60-4862-4852-a0c9-752379e9ea3a.jpg",
        title: "Shift Soft Stretchy Solid Color Long Sleeve T-shirt",
        a: "$25.90"
      },
      {
        url: "/products/shift-scoop-ribbed-padded-yoga-bra-womens-light-support-sports-bra-dark-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_4d7b1619-ae08-4f19-99f6-99ec103f98d9.jpg",
        title: "Shift Scoop Ribbed Padded Yoga Bra",
        a: "$39.00"
      }
    ]
  },
  "S110438A08_09A Black": {
    items: [
       {
        url: "/products/shift-soft-stretchy-solid-color-long-sleeve-t-shirt-womens-long-sleeve-t-shirt-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_fce1854d-b790-41ab-8ff6-a0867186d861.jpg",
        title: "Shift Soft Stretchy Solid Color Long Sleeve T-shirt",
        a: "$25.90"
      },
      {
        url: "/products/shift-scoop-ribbed-padded-yoga-bra-womens-light-support-sports-bra-dark-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_4d7b1619-ae08-4f19-99f6-99ec103f98d9.jpg",
        title: "Shift Scoop Ribbed Padded Yoga Bra",
        a: "$39.00"
      }
    ]
  },
  "S110438A08_09A Black": {
    items: [
       {
        url: "/products/shift-soft-stretchy-solid-color-long-sleeve-t-shirt-womens-long-sleeve-t-shirt-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_fce1854d-b790-41ab-8ff6-a0867186d861.jpg",
        title: "Shift Soft Stretchy Solid Color Long Sleeve T-shirt",
        a: "$25.90"
      },
      {
        url: "/products/shift-longline-mesh-strappy-padded-yoga-bra-womens-light-support-sports-bra-olive",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_27dd893c-fa94-47ef-b0be-7aca18e2eaba.jpg",
        title: "Shift Longline Mesh Strappy Padded Yoga Bra",
        a: "$39.00"
      },
      {
        url: "/products/shift-scoop-ribbed-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_1588d88e-7a8a-4ded-bf04-cbfc9c2ef72c.jpg",
        title: "Shift Scoop Ribbed Padded Yoga Bra",
        a: "$39.00"
      }
    ]
  },
  "S110438A08_31G Beige": {
    items: [
       {
        url: "/products/shift-soft-stretchy-solid-color-long-sleeve-t-shirt-womens-long-sleeve-t-shirt-beige",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_72c2c9ed-f1ff-4dd7-bb86-9c49dfee5760.jpg",
        title: "Shift Soft Stretchy Solid Color Long Sleeve T-shirt",
        a: "$25.90"
      },
      {
        url: "/products/shift-longline-mesh-strappy-padded-yoga-bra-womens-light-support-sports-bra-milky-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bb79f03f-f7dc-47f1-8950-4a541b0eea42.jpg",
        title: "Shift Longline Mesh Strappy Padded Yoga Bra",
        a: "$39.00"
      },
      {
        url: "/products/shift-scoop-ribbed-padded-yoga-bra-womens-light-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_46bc5e9f-aa12-4dc7-a444-39c92d83c866.jpg",
        title: "Shift Scoop Ribbed Padded Yoga Bra",
        a: "$39.00"
      }
    ]
  },
  "120754A08_31G Beige": {
    items: [
       {
        url: "/products/anywhere-high-waist-soft-warm-leggings-27-womens-high-support-leggings-beige",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_b4b6e9b4-eb93-4f9e-8afa-a012f351e611.jpg",
        title: "Anywhere High Waist Soft Warm Leggings 27",
        a: "$22.90"
      },
      {
        url: "/products/women-high-waisted-perforated-running-leggings-35i-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_ccc833bd-97a4-4ba7-9c18-c438cc8339e7.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      }
    ]
  },
  "120754A08_09A Black": {
    items: [
       {
        url: "/products/anywhere-high-waist-soft-warm-leggings-27-womens-high-support-leggings-beige",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_b4b6e9b4-eb93-4f9e-8afa-a012f351e611.jpg",
        title: "Anywhere High Waist Soft Warm Leggings 27",
        a: "$22.90"
      },
      {
        url: "/products/women-high-waisted-perforated-running-leggings-35i-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_ccc833bd-97a4-4ba7-9c18-c438cc8339e7.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      }
    ]
  },
  "120754A08_35C Light Brown": {
    items: [
       {
        url: "/products/anywhere-high-waist-soft-warm-leggings-27-womens-high-support-leggings-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_76390ac0-35f1-49c7-8fc6-94b4a7a16954.jpg",
        title: "Anywhere High Waist Soft Warm Leggings 27",
        a: "$22.90"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/women-high-waisted-perforated-running-leggings-35i-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_ccc833bd-97a4-4ba7-9c18-c438cc8339e7.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      }
    ]
  },
  "S100714A21_09A Black": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/shift-fleece-water-resistant-stretchy-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ee9a726b-859d-465e-8add-2f4040746b1f.jpg",
        title: "Shift Fleece Water Resistant Stretchy Full Zip Jacket",
        a: "$46.90"
      }
    ]
  },
  "S100714A21_35C Brown": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/shift-fleece-water-resistant-stretchy-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ee9a726b-859d-465e-8add-2f4040746b1f.jpg",
        title: "Shift Fleece Water Resistant Stretchy Full Zip Jacket",
        a: "$46.90"
      }
    ]
  },
  "S100714A21_73G Purple": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/shift-fleece-water-resistant-stretchy-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ee9a726b-859d-465e-8add-2f4040746b1f.jpg",
        title: "Shift Fleece Water Resistant Stretchy Full Zip Jacket",
        a: "$46.90"
      }
    ]
  },
  "140605A08_09A Black": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E110688A06_09A1 Black": {
    items: [
       {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/power-classic-zip-running-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112882.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_870c73f7-925e-4b68-8a04-011afcd6aee3.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_ca5c79d0-22b6-436d-b8f7-7291d39ed4bd.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-olive",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_f1661869-14d8-42d5-aaae-bb56b3bc04ce.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      }
    ]
  },
  "140598A08_09A Black": {
    items: [
       {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
       {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
       {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      }
    ]
  },
  "E101071A06_00A White": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      }
    ]
  },
  "E101071A06_09A Black": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
       {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      }
    ]
  },
  "140479A08_08T Dark Grey": {
    items: [
       {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
       {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      }
    ]
  },
  "140479A08_09A Black": {
    items: [
       {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
       {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      }
    ]
  },
  "E100977A08_71C Purple": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-stretchy-solid-capri-leggings-womens-high-support-capri-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a20f8515-b91c-4f61-85d2-19cf46e3c266.jpg",
        title: "Anywhere Stretchy Streamlined leggings 21",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100977A08_09A Black": {
    items: [
       {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100977A08_10AJ Pink": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "S100804A06_25E Orange": {
    items: [
       {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_46cdb7d8-7b15-41f4-b4db-9697a6a52111.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "S100804A06_33F Khaki": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-dark-blue-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_604e333d-e4dc-430f-9253-fdeaebe215da.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "S100804A06_13K Red": {
    items: [
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-rose-red-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c8266964-4c66-4b0e-aa3b-d8d5088f9e22.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100804A06_67F Blue": {
    items: [
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-dark-blue-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_604e333d-e4dc-430f-9253-fdeaebe215da.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100804A06_15E Red": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-purple-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_67acac18-f531-43d0-88db-37cac28df0a3.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "S100804A06_09A Black": {
    items: [
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-black-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1f0ec0b4-7ab5-4251-b471-1204b355b4c8.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/sculpt-mesh-pockets-tennis-skirt-womens-sports-skirt-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cf25a317-501a-4ea4-ae06-2914876d36c4.jpg",
        title: "Sculpt Mesh Pockets Tennis Skirt",
        a: "$44.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100804A06_58D Dark Green": {
    items: [
       {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100804A06_35G Brown": {
    items: [
       {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-dark-blue-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_604e333d-e4dc-430f-9253-fdeaebe215da.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E100949A08_09A Black": {
    items: [
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100949A08_01F Off White": {
    items: [
       {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E140460AB01_26088 Blue": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      }
    ]
  },
  "S100712A08_54AB Green": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "S100712A08_00A White": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "S100712A08_09A Black": {
    items: [
       {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E110671A08_15F Red": {
    items: [
       {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_1aadf7ee-b398-4848-9e51-78ea7d353aa6.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_25df6749-d487-4d2d-bf18-01ddbb25f69e.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-dark-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_a7ebf64e-9f6f-4b17-b609-76701f678f71.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E110671A08_09A Black": {
    items: [
       {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_1aadf7ee-b398-4848-9e51-78ea7d353aa6.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_25df6749-d487-4d2d-bf18-01ddbb25f69e.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-dark-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_a7ebf64e-9f6f-4b17-b609-76701f678f71.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E110671A08_68B Blue": {
    items: [
       {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-dark-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_a7ebf64e-9f6f-4b17-b609-76701f678f71.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_1aadf7ee-b398-4848-9e51-78ea7d353aa6.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-keyhole-perforated-padded-running-bra-womens-high-support-sports-bra-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_25df6749-d487-4d2d-bf18-01ddbb25f69e.jpg",
        title: "Echo Front Zip Keyhole Perforated Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E110657A06INT_78A Purple": {
    items: [
       {
        url: "/products/power-adjustable-running-bra-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033111449.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      },
      {
        url: "/products/power-adjustable-padded-running-bra-womens-high-support-sports-bra-plus-size-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_4de55ecc-998d-448b-932f-21dd15ba06f2.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      },
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c3b2fdb7-fb9f-423e-ab86-522a3cc6a1fc.jpg",
        title: "Shift Scoop Neckline Strappy Padded Yoga Bra",
        a: "$29.00"
      }
    ]
  },
  "E110657A06INT_69A Dark Blue": {
    items: [
       {
        url: "/products/shift-racerback-mesh-padded-running-bra-womens-high-support-sports-bra-navy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_c469f158-5653-4000-883f-6e815f6f9ca9.jpg",
        title: "Shift V-neck Mesh Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/shift-racerback-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-navy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_d77ee517-8f97-464d-bb64-38b418b43571.jpg",
        title: "Shift V-neck Mesh Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-classic-zip-running-bra-plus-size-blue-tide",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_546dcdc3-ea1b-4dbb-9968-c664b674fe47.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/power-classic-zip-running-bra-blue-tide",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033111905.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/echo-logo-mesh-zip-front-padded-running-bra-womens-high-support-sports-bra-navy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_30601908-6707-4612-9ec9-5384df0dbd00.jpg",
        title: "Echo Logo Mesh Zip Front Padded Running Bra",
        a: "$39.00"
      }
    ]
  },
  "E110657A06INT_56B Olive": {
    items: [
       {
        url: "/products/shift-scoop-neckline-longline-mesh-padded-yoga-bra-womens-light-support-sports-bra-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_d353c103-6cc1-4ac0-bc11-037115fbd047.jpg",
        title: "Shift Scoop Neckline Longline Mesh Padded Yoga Bra",
        a: "$33.00"
      },
      {
        url: "/products/echo-logo-mesh-zip-front-padded-running-bra-womens-high-support-sports-bra-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_fe4b411e-cb08-46f0-978b-3fe3dc6556b8.jpg",
        title: "Echo Logo Mesh Zip Front Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_b3873c3e-f0a8-462c-896e-324c2e22d418.jpg",
        title: "Shift Scoop Neckline Strappy Padded Yoga Bra",
        a: "$29.00"
      }
    ]
  },
  "E110657A06INT_11E Pink": {
    items: [
       {
        url: "/products/power-v-neck-cross-back-padded-running-bra-womens-high-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_36a7d51d-0434-4b69-9c1f-438d1c594197.jpg",
        title: "Power V-Neck Cross Back Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/shift-scoop-neckline-cross-back-padded-yoga-bra-womens-light-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c4d598a7-5906-4e2c-84d4-7ff3c7619e78.jpg",
        title: "Shift Scoop Neckline Cross Back Padded Yoga Bra",
        a: "$29.00"
      },
      {
        url: "/products/power-classic-zip-running-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/202204180259.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      }
    ]
  },
  "E110657A06INT_09A Black": {
    items: [
       {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_e3885427-6a20-485a-98a9-bd37f964a6e8.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_4ce4e2ac-3889-45a8-b3a3-3eaf13691967.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$35.00"
      }
    ]
  },
  "E110657A06INT_05D Medium Grey": {
    items: [
       {
        url: "/products/power-classic-zip-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112994.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/power-classic-zip-running-bra-plus-size-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_fd3d717b-fa8a-414f-b52e-7da3bbcba21f.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2f33aded-e730-49a0-a814-ef6aa8fe2111.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/enfold-longline-hollow-racerback-padded-running-bra-womens-high-support-sports-bra-grey-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b172950-1e7f-4ffc-8548-6792da99a920.jpg",
        title: "Enfold Longline Hollow Racerback Padded Running Bra",
        a: "$38.00"
      }
    ]
  },
  "E110688A06_09A Black": {
    items: [
       {
        url: "/products/shift-fleece-full-zip-jacket-womens-sports-jacket",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_47284126-ca2d-43a6-8e80-4b5c94be87c2.jpg",
        title: "Shift Slim Fit Fleece Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/power-classic-zip-running-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112882.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_870c73f7-925e-4b68-8a04-011afcd6aee3.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_ca5c79d0-22b6-436d-b8f7-7291d39ed4bd.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-olive",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_f1661869-14d8-42d5-aaae-bb56b3bc04ce.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      }
    ]
  },
  "E100968A08_68B Blue": {
    items: [
       {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-blue1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bf651758-431a-4cb3-9a61-465ef3902db7.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_7931bf4a-61a1-4fa6-b847-99b789ad48c2.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-red2",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_32f2a563-7186-43c1-8bf1-ecfa26dc150c.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      }
    ]
  },
  "E100968A08_01F Off White": {
    items: [
       {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-blue1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bf651758-431a-4cb3-9a61-465ef3902db7.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_7931bf4a-61a1-4fa6-b847-99b789ad48c2.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-red2",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_32f2a563-7186-43c1-8bf1-ecfa26dc150c.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      }
    ]
  },
  "E100968A08_34C Brown": {
    items: [
       {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-blue1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bf651758-431a-4cb3-9a61-465ef3902db7.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_7931bf4a-61a1-4fa6-b847-99b789ad48c2.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-red2",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_32f2a563-7186-43c1-8bf1-ecfa26dc150c.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      }
    ]
  },
  "E110615A19_07R Gray": {
    items: [
      {
        url: "/products/shift-scoop-neckline-cross-back-padded-yoga-bra-womens-light-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c4d598a7-5906-4e2c-84d4-7ff3c7619e78.jpg",
        title: "Shift Scoop Neckline Cross Back Padded Yoga Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2f33aded-e730-49a0-a814-ef6aa8fe2111.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/shift-scoop-neckline-double-straps-padded-yoga-bra-womens-light-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4c18e57a-8074-4089-b069-deb992152547.jpg",
        title: "Shift Scoop Neckline Double Straps Padded Yoga Bra",
        a: "$29.00"
      }
    ]
  },
  "E110615A19_09A Black": {
    items: [
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-black1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_82663c4a-4840-4fa2-b4f9-f0b1f0b0c606.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$42.90"
      },
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_4ce4e2ac-3889-45a8-b3a3-3eaf13691967.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_154cff11-c235-4e9f-a33b-791780cc36ca.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e38c17c4-32e4-4a86-b1ab-ec3b3f169767.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      }
    ]
  },
  "E110610A21_75N Purple": {
    items: [
      {
        url: "/products/echo-logo-mesh-zip-front-padded-running-bra-womens-high-support-sports-bra-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_d531be73-c19a-43a2-b7e2-669f09ed05e4.jpg",
        title: "Echo Logo Mesh Zip Front Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_e12cd747-432b-4ae3-85ee-02497fb04b0d.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_098fa4ec-fa93-457e-8606-fbae7ae92d3f.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/power-zip-front-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-blue-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_e941d4c0-50b8-44aa-a7ef-60f8b990b16b.jpg",
        title: "Power Zip Front Criss Cross Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/power-zip-front-criss-cross-padded-running-bra-womens-high-support-sports-bra-blue-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_434f65d0-3568-4b7b-867b-22eea871c4ee.jpg",
        title: "Power Zip Front Criss Cross Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E110610A21_09A Black": {
    items: [
      {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_d8334503-4bfc-4ea3-a771-aa9bfd567a9f.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$34.00"
      },
      {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_9d30f37f-881e-4121-a70f-a66f20040c18.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$34.00"
      },
      {
        url: "/products/anywhere-round-neck-mesh-short-running-t-shirt-womens-sports-t-shirt-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8a62ea6a-c56d-4528-a67d-ad73c751d135.jpg",
        title: "Anywhere Round Neck Mesh Short Running T-shirt",
        a: "$49.00"
      }
    ]
  },
  "E110603A21_09A Black": {
    items: [
      {
        url: "/products/sculpt-criss-cross-padded-gym-bra-womens-high-support-sports-bra-plus-size-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/5_42ae75c8-20b5-4277-968a-1c7a5f1d37c3.jpg",
        title: "Sculpt Criss Cross Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/sculpt-criss-cross-padded-gym-bra-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_2d41af36-2098-480f-813b-298db1dc61e7.jpg",
        title: "Sculpt Criss Cross Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/enfold-zip-front-padded-running-bra-caesious-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ebf2539e-41e1-41ec-ba71-d4ad615d2d4a.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/enfold-zip-front-padded-running-bra-womens-high-support-sports-bra-plus-size-caesious-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_04b21f18-0b11-4f20-b034-baecf4f2b9f1.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E110594A08_09A Black": {
    items: [
      {
        url: "/products/shift-fleece-slim-fit-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_92db3082-c565-4b36-a1b7-7010a5448a93.jpg",
        title: "Shift Fleece Light Stretchy Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bd99720-995d-4515-b0d5-e769fa9e912c.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_163f88f4-58c9-4e4f-a6ea-c0bf1d229f51.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/shift-fleece-water-resistant-stretchy-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ee9a726b-859d-465e-8add-2f4040746b1f.jpg",
        title: "Shift Fleece Water Resistant Stretchy Full Zip Jacket",
        a: "$46.90"
      }
    ]
  },
  "E110491B19_67T Blue": {
    items: [
      {
        url: "/products/enfold-zip-front-padded-running-bra-blue-camo-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_837175fc-923d-43a5-b8dc-583ea3911080.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/enfold-zip-front-padded-running-bra-womens-high-support-sports-bra-plus-size-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_b602c436-bfa6-43bf-be75-07f4ea3e4ec7.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f8863838-01b8-4ef6-bf4b-b54282609a4e.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_9a302584-b766-4c90-9c0f-eb3b981b10d4.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      }
    ]
  },
  "E110443A21_19F Wine": {
    items: [
      {
        url: "/products/enfold-longline-hollow-racerback-padded-running-bra-womens-high-support-sports-bra-grey-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b172950-1e7f-4ffc-8548-6792da99a920.jpg",
        title: "Enfold Longline Hollow Racerback Padded Running Bra",
        a: "$38.00"
      },
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4a3aec6f-6294-4c54-9b1a-96c387a5b247.jpg",
        title: "Enfold Zip Front Mesh Racerback Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E110443A21_68A Blue": {
    items: [
      {
        url: "/products/echo-logo-mesh-zip-front-padded-running-bra-womens-high-support-sports-bra-navy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_30601908-6707-4612-9ec9-5384df0dbd00.jpg",
        title: "Echo Logo Mesh Zip Front Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/power-classic-zip-running-bra-plus-size-blue-tide",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_546dcdc3-ea1b-4dbb-9968-c664b674fe47.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/power-classic-zip-running-bra-blue-tide",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033111905.jpg",
        title: "Power Classic Zip Running Bra",
        a: "$28.00"
      }
    ]
  },
  "E110443A21_09A Black": {
    items: [
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a456bf2b-58ab-4cab-a1e4-34ef95c6ce31.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E100985A21_00A White": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18a68481-6eea-451f-9a3c-ce42c8679fc1.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "E100985A21_07R Gray": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-capri-leggings-womens-high-support-capri-leggings-gray",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_5164a27b-c1a1-4f0c-be36-de1bd0a12fc3.jpg",
        title: "7/8 Anywhere Stretchy Tummy control leggings 24",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$34.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E100985A21_70B Light Purple": {
    items: [
      {
        url: "/products/echo-stretchy-solid-capri-leggings-womens-high-support-capri-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a20f8515-b91c-4f61-85d2-19cf46e3c266.jpg",
        title: "Anywhere Stretchy Streamlined leggings 21",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100985A21_09A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "E100835A08_62C Blue": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$34.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E100835A08_09A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$34.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E100835A08_55M Green": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$34.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E110314C06_23PTC Orange": {
    items: [
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-womens-high-support-sports-bra-rose",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_d0e99ef3-477b-4e42-a982-16136e83e721.jpg",
        title: "Enfold Zip Front Mesh Racerback Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/power-back-orange-womens-high-support-running-sports-bra",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_083da202-5b71-4747-b007-832586c010e6.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_a64fcc52-c795-42e6-b826-924aa04e09fd.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-vermilion",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_6022020a-e647-4a93-8ec7-2f7bf3c17e21.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      }
    ]
  },
  "E110314C06_1PTG Off White": {
    items: [
      {
        url: "/products/power-v-neck-cross-back-padded-running-bra-womens-high-support-sports-bra-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_64702831-5846-4ef9-8f26-4c96bcddb47e.jpg",
        title: "Power V-Neck Cross Back Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/enfold-zip-front-padded-running-bra-white-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ef4283a7-2c68-4e29-b1eb-224646e9c93c.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E150384A28_56Q Olive": {
    items: [
      {
        url: "/products/shift-mock-neck-thumbhole-full-zip-jacket-olive",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_261e5ec0-67c3-487f-ab1c-fc82c542950c.jpg",
        title: "Shift Mock Neck Thumbhole Full Zip Jacket",
        a: "$68.00"
      },
      {
        url: "/products/echo-logo-mesh-zip-front-padded-running-bra-womens-high-support-sports-bra-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_fe4b411e-cb08-46f0-978b-3fe3dc6556b8.jpg",
        title: "Echo Logo Mesh Zip Front Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E100994A19_10AJ Pink": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$39.00"
      }
    ]
  },
  "E100994A19_70D Light Purple": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-stretchy-solid-capri-leggings-womens-high-support-capri-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a20f8515-b91c-4f61-85d2-19cf46e3c266.jpg",
        title: "Anywhere Stretchy Streamlined leggings 21",
        a: "$29.00"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$28.00"
      }
    ]
  },
  "S100744A06_29005 Blue": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-stretchy-butt-sculpting-biker-shorts-womens-high-support-biker-shorts-wine",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_8dadc5c5-bb6b-49de-a404-6cec41fd5990.jpg",
        title: "Anywhere Stretchy Butt-sculpting Biker Shorts 8",
        a: "$28.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      }
    ]
  },
  "S100744A06_09A Black": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-stretchy-butt-sculpting-biker-shorts-womens-high-support-biker-shorts-wine",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_8dadc5c5-bb6b-49de-a404-6cec41fd5990.jpg",
        title: "Anywhere Stretchy Butt-sculpting Biker Shorts 8",
        a: "$28.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      }
    ]
  },
  "S100744A06_00A White": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-stretchy-butt-sculpting-biker-shorts-womens-high-support-biker-shorts-wine",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_8dadc5c5-bb6b-49de-a404-6cec41fd5990.jpg",
        title: "Anywhere Stretchy Butt-sculpting Biker Shorts 8",
        a: "$28.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      }
    ]
  },
  
  "S100744A06_36K Medium Brown": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-stretchy-butt-sculpting-biker-shorts-womens-high-support-biker-shorts-wine",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_8dadc5c5-bb6b-49de-a404-6cec41fd5990.jpg",
        title: "Anywhere Stretchy Butt-sculpting Biker Shorts 8",
        a: "$28.00"
      },
      {
        url: "/products/soft-elastic-high-waist-mesh-running-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bfd61a65-255a-4fbc-9995-8c9d18f5c8e2.jpg",
        title: "Soft Elastic High-Waist Mesh Running Shorts",
        a: "$27.00"
      }
    ]
  },
  "E110674A06_09A Black": {
    items: [
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_e3885427-6a20-485a-98a9-bd37f964a6e8.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4e60f411-44f3-4d0d-8ee7-88f20eebdb7d.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_fda426b8-2951-4a25-a382-ad6bd23cbe79.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      }
    ]
  },
  "E150262A08_35D Light Brown": {
    items: [
      {
        url: "/products/shift-mock-neck-thumbhole-full-zip-jacket-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_6635e8e0-0484-4e3c-a1de-06942eb2b18a.jpg",
        title: "Shift Abstract Pattern Full Zip Jacket",
        a: "$49.90"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a456bf2b-58ab-4cab-a1e4-34ef95c6ce31.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/shift-fleece-water-resistant-stretchy-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ee9a726b-859d-465e-8add-2f4040746b1f.jpg",
        title: "Shift Fleece Water Resistant Stretchy Full Zip Jacket",
        a: "$46.90"
      }
    ]
  },
  "E120211A03_02IM Grey": {
    items: [
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_6e6cd817-07bb-4d34-8138-dd9b830222f1.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4a3aec6f-6294-4c54-9b1a-96c387a5b247.jpg",
        title: "Enfold Zip Front Mesh Racerback Padded Running Bra",
        a: "$38.99"
      }
    ]
  },
  "E120386A03AS_66T Blue": {
    items: [
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c87d8b17-4a18-4d94-b640-4dd83994fa2e.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5cb5809a-19ec-499b-b134-2c285f5e86fe.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$35.00"
      }
    ]
  },
  "E120386A03AS_70O Light Purple": {
    items: [
      {
        url: "/products/echo-stretchy-solid-capri-leggings-womens-high-support-capri-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a20f8515-b91c-4f61-85d2-19cf46e3c266.jpg",
        title: "Anywhere Stretchy Streamlined leggings 21",
        a: "$29.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_e12cd747-432b-4ae3-85ee-02497fb04b0d.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_098fa4ec-fa93-457e-8606-fbae7ae92d3f.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$37.99"
      }
    ]
  },
  "E120386A03AS_58H Dark Green": {
    items: [
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bd20f125-3581-4336-b634-d1c98a676747.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E120386A03AS_26B Orange Red": {
    items: [
      {
        url: "/products/power-v-neck-cross-back-padded-running-bra-womens-high-support-sports-bra-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_64702831-5846-4ef9-8f26-4c96bcddb47e.jpg",
        title: "Power V-Neck Cross Back Padded Running Bra",
        a: "$36.99"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_46cdb7d8-7b15-41f4-b4db-9697a6a52111.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E120386A03AS_00A White": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-brushed-soft-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_d96abd40-661b-476a-a2a9-316b9887b8fc.jpg",
        title: "Shift High Waist Brushed Soft Yoga Leggings 25 27",
        a: "$49.90"
      }
    ]
  },
  "E110472B08AS_38H Dark Brown": {
    items: [
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a456bf2b-58ab-4cab-a1e4-34ef95c6ce31.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      }
    ]
  },
  "E110472B08AS_22PTA Print": {
    items: [
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a456bf2b-58ab-4cab-a1e4-34ef95c6ce31.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      }
    ]
  },
  "S120508A03_09A Black": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "S120508A03_01F Milky White": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "S120508A03_56A Olive": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S150250A03AS_66V Blue": {
    items: [
      {
        url: "/products/power-zipper-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/5_0d4ccb92-f401-4b26-a4ff-565b6a9220ad.jpg",
        title: "Power Zipper Mesh Racerback Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/power-zipper-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_6fe92403-c633-4392-978d-dee0a9e74561.jpg",
        title: "Power Zipper Mesh Racerback Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/power-zipper-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_5386903c-d18c-47f1-9be3-12c036fdfd3e.jpg",
        title: "Power Zipper Mesh Racerback Padded Running Bra",
        a: "$39.00"
      }
    ]
  },
  "S150250A03AS_00A White": {
    items: [
      {
        url: "/products/power-zipper-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/5_0d4ccb92-f401-4b26-a4ff-565b6a9220ad.jpg",
        title: "Power Zipper Mesh Racerback Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/power-zipper-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_6fe92403-c633-4392-978d-dee0a9e74561.jpg",
        title: "Power Zipper Mesh Racerback Padded Running Bra",
        a: "$39.00"
      },
      {
        url: "/products/power-zipper-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_5386903c-d18c-47f1-9be3-12c036fdfd3e.jpg",
        title: "Power Zipper Mesh Racerback Padded Running Bra",
        a: "$39.00"
      }
    ]
  },
  "S100619A03_58H Dark Green": {
    items: [
      {
        url: "/products/power-zipper-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/5_0d4ccb92-f401-4b26-a4ff-565b6a9220ad.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100619A03_70A Light Purple": {
    items: [
      {
        url: "/products/echo-stretchy-solid-capri-leggings-womens-high-support-capri-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a20f8515-b91c-4f61-85d2-19cf46e3c266.jpg",
        title: "Anywhere Stretchy Streamlined leggings 21",
        a: "$29.00"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$37.99"
      }
    ]
  },
  "S100733A06_00A White": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      }
    ]
  },
  "S100733A06_09A Black": {
    items: [
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      },
      {
        url: "/products/shift-drop-shoulder-drawcord-hoodie-womens-sports-hoodie-camel",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_9374db46-dff4-4547-b028-c46dab39af26.jpg",
        title: "Shift Drop Shoulder Drawcord Hoodie",
        a: "$59.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },


  "S100733A06_75A Purple": {
    items: [
      {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$37.99"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "S100733A06_54A Green": {
    items: [
      {
        url: "/products/echo-high-waist-perforated-zip-pocket-biker-shorts-womens-high-support-sports-shorts-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_-2_8748fdf2-6bfb-40c6-87d1-e3c11eb2748b.jpg",
        title: "Echo High-Waist Perforated Zip Pocket Biker Shorts",
        a: "$38.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "S100617A01_42A Light Yellow": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S100617A01_56A Olive": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S100617A01_01F Milky White": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S100637A08_42A Light Yellow": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/sculpt-mesh-pockets-tennis-skirt-womens-sports-skirt-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/5_e69ad21c-4147-4906-aca8-8db26134d628.jpg",
        title: "Sculpt Mesh Pockets Tennis Skirt",
        a: "$44.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_ef430b94-d247-463d-8883-ba90b5ef2221.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100637A08_56A Olive": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/sculpt-mesh-pockets-tennis-skirt-womens-sports-skirt-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/5_e69ad21c-4147-4906-aca8-8db26134d628.jpg",
        title: "Sculpt Mesh Pockets Tennis Skirt",
        a: "$44.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100672A30_38D Dark Brown": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S100672A30_09A Black": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S100672A30_00A White": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S100648A28_09A Black": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/women-high-waisted-perforated-running-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_5e93570e-d79b-43ae-a8a0-223865564d8e.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      },
      {
        url: "/products/enfold-high-waist-pockets-stretchy-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_71ede721-834b-490b-891b-30ebaa80085c.jpg",
        title: "Enfold High Waist Pockets Stretchy Running Leggings 26",
        a: "$49.00"
      }
    ]
  },
  "E100856A19_07R Grey": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$37.99"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E100856A19_08A Dark Grey": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$37.99"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E100856A19_09A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E110542A28AS_54AB Green": {
    items: [
      {
        url: "/products/power-cross-racerback-running-bra-womens-high-support-sports-bra-plus-size-light-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_cedfd32c-a3f4-411d-b606-08be1ee1ae2f.jpg",
        title: "Power Cross Racerback Running Bra",
        a: "$34.00"
      },
      {
        url: "/products/shift-fitted-mesh-padded-t-shirt-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_3e448d22-f735-4184-b54a-059b3ebd7519.jpg",
        title: "Shift Fitted Mesh Padded T-shirt",
        a: "$44.00"
      },
      {
        url: "/products/shift-textured-drawstring-waist-jacket-womens-sports-jacket-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_08a04d67-f68c-4249-aed1-9eaa1429f0c3.jpg",
        title: "Shift Textured Drawstring Waist Fleece lined Jacket",
        a: "$94.00"
      },
      {
        url: "/products/power-cross-racerback-running-bra-womens-high-support-sports-bra-4-light-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_7dbd330a-2f48-47e9-ae00-3b18f2e2f9df.jpg",
        title: "Power Cross Racerback Running Bra",
        a: "$34.00"
      }
    ]
  },
  "E110542A28AS_35I Light Brown": {
    items: [
      {
        url: "/products/echo-seamless-racerback-padded-yoga-bra-womens-light-support-sports-bra-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_32e3de5f-4766-4f4c-b856-b3a1e67e369c.jpg",
        title: "Echo Seamless Racerback Padded Yoga Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-cut-out-racerback-padded-running-bra-womens-high-support-sports-bra-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_3189e3b3-dc40-4955-a7c0-b12dd74b6a6a.jpg",
        title: "Enfold Cut Out Racerback Padded Running Bra",
        a: "$29.00"
      }
    ]
  },
  "E110542A28AS_09A Black": {
    items: [
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-09ablack",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_24afcd54-24f9-4daa-bd26-a9d761c26768.jpg",
        title: "Echo Hollow Out Breathable Padded Running Bra",
        a: "$39.90"
      }
    ]
  },
  "E120441A08_09A Black": {
    items: [
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "E120441A08_58H Dark Green": {
    items: [
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "E120441A08_70A Light Purple": {
    items: [
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S110370A27_09A Black": {
    items: [
      {
        url: "/products/anywhere-high-neck-padded-gym-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_93139dfb-97fb-4cd0-ac8d-76187cd2db34.jpg",
        title: "Anywhere High Neck Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_4ce4e2ac-3889-45a8-b3a3-3eaf13691967.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$35.00"
      },
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_e3885427-6a20-485a-98a9-bd37f964a6e8.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      }
    ]
  },
  "E110420C27_09A Black": {
    items: [
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-blue-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2026b2ac-66f2-4327-b72c-4eb112b67c52.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a456bf2b-58ab-4cab-a1e4-34ef95c6ce31.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-09ablack",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_24afcd54-24f9-4daa-bd26-a9d761c26768.jpg",
        title: "Echo Hollow Out Breathable Padded Running Bra",
        a: "$39.90"
      }
    ]
  },
  "E110417A21_05D Medium Grey": {
    items: [
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4a3aec6f-6294-4c54-9b1a-96c387a5b247.jpg",
        title: "Enfold Zip Front Mesh Racerback Padded Running Bra",
        a: "$38.99"
      },
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_6e6cd817-07bb-4d34-8138-dd9b830222f1.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_95cd47b9-7f5a-4a16-9594-d427a0a56836.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_87dd0978-a085-4877-add0-30f4fd22ccdb.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      }
    ]
  },
  "E100860A06_65B Royal Blue": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      }
    ]
  },
  "E100860A06_606036 Orange Yellow": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      }
    ]
  },
  "E100860A06_26077 Bright Green": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      }
    ]
  },
  "E100771B21_67U Sea Blue": {
    items: [
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_-2_3cc95bac-6125-4280-878b-f07595f24819.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      },
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_7db4f6b6-0d72-4c20-a7db-e13836859f5c.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      }
    ]
  },
  "E100771B21_42M Light Yellow": {
    items: [
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_-2_3cc95bac-6125-4280-878b-f07595f24819.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      },
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_7db4f6b6-0d72-4c20-a7db-e13836859f5c.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      }
    ]
  },
  "E100771B21_35J Light Brown": {
    items: [
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_-2_3cc95bac-6125-4280-878b-f07595f24819.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      },
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_7db4f6b6-0d72-4c20-a7db-e13836859f5c.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      }
    ]
  },
  "E100879A06_09A Black": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E100879A06_08A Dark Grey": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E100879A06_00A White": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E110624A21_09A Black": {
    items: [
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a456bf2b-58ab-4cab-a1e4-34ef95c6ce31.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_d8334503-4bfc-4ea3-a771-aa9bfd567a9f.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$42.90"
      },
      {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_9d30f37f-881e-4121-a70f-a66f20040c18.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$42.90"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_154cff11-c235-4e9f-a33b-791780cc36ca.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e38c17c4-32e4-4a86-b1ab-ec3b3f169767.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      }
    ]
  },

  "E110624A21_07R Grey": {
    items: [
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2f33aded-e730-49a0-a814-ef6aa8fe2111.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/enfold-longline-hollow-racerback-padded-running-bra-womens-high-support-sports-bra-grey-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b172950-1e7f-4ffc-8548-6792da99a920.jpg",
        title: "Enfold Longline Hollow Racerback Padded Running Bra",
        a: "$38.99"
      },
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4a3aec6f-6294-4c54-9b1a-96c387a5b247.jpg",
        title: "Enfold Zip Front Mesh Racerback Padded Running Bra",
        a: "$38.99"
      }
    ]
  },

  "E100796C19_50H Light Green": {
    items: [
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_7931bf4a-61a1-4fa6-b847-99b789ad48c2.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-blue1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bf651758-431a-4cb3-9a61-465ef3902db7.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-orange",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_afa225d1-43af-47c9-b488-3a4a7ebe5926.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$31.99"
      }
    ]
  },
  "E100796C19_00A White": {
    items: [
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-black3",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_7931bf4a-61a1-4fa6-b847-99b789ad48c2.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-butt-lifting-running-leggings-blue1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_bf651758-431a-4cb3-9a61-465ef3902db7.jpg",
        title: "Echo High-Waisted Butt lifting Running Leggings 26",
        a: "$49.90"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-orange",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_afa225d1-43af-47c9-b488-3a4a7ebe5926.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$31.99"
      }
    ]
  },
  "E110464A21AS_09A Black": {
    items: [
      {
        url: "/products/power-zip-color-clash-padded-running-bra-womens-high-support-sports-bra-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_ba2a3d3f-a64f-40a8-8209-42fe90124031.jpg",
        title: "Power Zip Color Clash Padded Running Bra",
        a: "$22.00"
      },
      {
        url: "/products/power-zip-color-clash-padded-running-bra-womens-high-support-sports-bra-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_4e6fa609-ab9d-4897-81f4-4840aa1e29b3.jpg",
        title: "Power Zip Color Clash Padded Running Bra",
        a: "$22.00"
      }
    ]
  },
  "E110464A21AS_58A Dark Green": {
    items: [
      {
        url: "/products/power-zip-color-clash-padded-running-bra-womens-high-support-sports-bra-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_ba2a3d3f-a64f-40a8-8209-42fe90124031.jpg",
        title: "Power Zip Color Clash Padded Running Bra",
        a: "$22.00"
      },
      {
        url: "/products/power-zip-color-clash-padded-running-bra-womens-high-support-sports-bra-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_4e6fa609-ab9d-4897-81f4-4840aa1e29b3.jpg",
        title: "Power Zip Color Clash Padded Running Bra",
        a: "$22.00"
      }
    ]
  },
  "S100743A06_08PTC Grey Print": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_09PTC Black Print": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_42A Light Yellow": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_ef430b94-d247-463d-8883-ba90b5ef2221.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_71A Light Purple": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-olive-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_7b23cb29-4ce6-4995-a174-1b35fdda88e6.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_36K Medium Brown": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-olive-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_7b23cb29-4ce6-4995-a174-1b35fdda88e6.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_54A Green": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waist-perforated-zip-pocket-biker-shorts-womens-high-support-sports-shorts-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_-2_8748fdf2-6bfb-40c6-87d1-e3c11eb2748b.jpg",
        title: "Echo High-Waist Perforated Zip Pocket Biker Shorts",
        a: "$38.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_11C Pink": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_ef430b94-d247-463d-8883-ba90b5ef2221.jpg",
        title: "Echo High-Waist Perforated Zip Pocket Biker Shorts",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_00A White": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "S100743A06_09A Black": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$31.90"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100841A08_15N Coral Red": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100841A08_50Q Light Green": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100841A08_55M Dark Green": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E100841A08_09A Black": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E140382A08_58H Dark Green": {
    items: [
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/echo-high-waist-four-way-stretch-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_83aa0066-3e33-4c12-838d-9a90397af115.jpg",
        title: "Sculpt Four-way Stretch Fleece Lined Leggings 26",
        a: "$33.99"
      },
      {
        url: "/products/sculpt-high-waist-water-resistant-fleece-leggings-26-womens-light-support-leggings",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_cdc94257-d01a-4f93-be9b-d7a171ecb808.jpg",
        title: "Sculpt Water Resistant Fleece Lined Leggings 26",
        a: "$33.99"
      }
    ]
  },
  "S120449A03_58H Dark Green": {
    items: [
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bd20f125-3581-4336-b634-d1c98a676747.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      },
      {
        url: "/products/echo-cut-out-racerback-longline-padded-yoga-bra-womens-light-support-sports-bra-light-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_75277a9c-a3df-43ba-b217-fe7444b26c97.jpg",
        title: "Echo Padded Round neck Yoga Bra",
        a: "$34.90"
      }
    ]
  },
  "E100718A03_09A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      }
    ]
  },
  "E120389A28_53C Green": {
    items: [
      {
        url: "/products/anywhere-pockets-pleated-track-pants-womens-sports-pants-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_0b60474c-4ee5-48b8-aff6-5f11d224a747.jpg",
        title: "Anywhere Pockets Pleated Track Pants",
        a: "$49.00"
      },
      {
        url: "/products/anywhere-pockets-pleated-track-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_6f85c8bb-dc48-424d-8b9f-32c308aa6849.jpg",
        title: "Anywhere Pockets Pleated Track Pants",
        a: "$49.00"
      },
      {
        url: "/products/shift-loose-webbing-belt-athflow-shorts-womens-shorts-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_3660e575-d19f-475b-9431-0c6ad68a0fb2.jpg",
        title: "Shift Loose Webbing Belt Athflow Shorts",
        a: "$49.00"
      }
    ]
  },
  "E120389A28_09A Black": {
    items: [
      {
        url: "/products/anywhere-pockets-pleated-track-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_6f85c8bb-dc48-424d-8b9f-32c308aa6849.jpg",
        title: "Anywhere Pockets Pleated Track Pants",
        a: "$49.00"
      },
      {
        url: "/products/anywhere-loose-braided-belt-athflow-shorts-womens-shorts",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_716c9ebe-7326-4f7f-9d11-b917ae40a67c.jpg",
        title: "Anywhere Loose Braided Belt Athflow Shorts",
        a: "$49.00"
      }
    ]
  },
  "E120389A28_01F Milky White": {
    items: [
      {
        url: "/products/anywhere-pockets-pleated-track-pants-womens-sports-pants-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_0b60474c-4ee5-48b8-aff6-5f11d224a747.jpg",
        title: "Anywhere Pockets Pleated Track Pants",
        a: "$49.00"
      },
      {
        url: "/products/anywhere-pockets-pleated-track-pants-womens-sports-pants-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_6f85c8bb-dc48-424d-8b9f-32c308aa6849.jpg",
        title: "Anywhere Pockets Pleated Track Pants",
        a: "$49.00"
      },
      {
        url: "/products/shift-loose-webbing-belt-athflow-shorts-womens-shorts-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_fa74317c-b83a-49e0-98ea-e501aee83ca6.jpg",
        title: "Shift Loose Webbing Belt Athflow Shorts",
        a: "$49.00"
      }
    ]
  },
  "E110423A03_53C Green": {
    items: [
      {
        url: "/products/echo-cut-out-racerback-longline-padded-yoga-bra-womens-light-support-sports-bra-light-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_75277a9c-a3df-43ba-b217-fe7444b26c97.jpg",
        title: "Echo Padded Round neck Yoga Bra",
        a: "$34.90"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-green",
        imageUrl: "/products/power-cross-back-padded-running-bra-green",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-light-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_62503a5c-1638-4ed1-b4e7-e1960d1e089a.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$42.90"
      },
      {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-light-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_151377bf-6ebc-48d7-a150-6fe6f43b5617.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$42.90"
      }
    ]
  },
  "E110423A03_09A Black": {
    items: [
      {
        url: "/products/enfold-hollow-out-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_154cff11-c235-4e9f-a33b-791780cc36ca.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e38c17c4-32e4-4a86-b1ab-ec3b3f169767.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-black-zip-front-racerback-padded-running-bra-womens-high-support-sports-bra",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_00ea9837-014f-4eb7-925f-0edad3e10291.jpg",
        title: "Enfold Zip Front Racerback Padded Running Bra",
        a: "$35.99"
      },
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-womens-high-support-sports-bra-plus-size-black-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_0d8c31c9-2902-4c3f-a676-9bf88888e94a.jpg",
        title: "Enfold Zip Front Racerback Padded Running Bra",
        a: "$35.99"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bd99720-995d-4515-b0d5-e769fa9e912c.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_163f88f4-58c9-4e4f-a6ea-c0bf1d229f51.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      }
    ]
  },
  
  "E110522B03AS_09A Black": {
    items: [
      {
        url: "/products/enfold-zip-front-padded-running-bra-blue-camo-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_837175fc-923d-43a5-b8dc-583ea3911080.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$19.99"
      },
      {
        url: "/products/enfold-zip-front-padded-running-bra-womens-high-support-sports-bra-plus-size-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_b602c436-bfa6-43bf-be75-07f4ea3e4ec7.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$19.99"
      },
      {
        url: "/products/enfold-zip-front-padded-running-bra-caesious-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ebf2539e-41e1-41ec-ba71-d4ad615d2d4a.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$19.99"
      },
      {
        url: "/products/enfold-zip-front-padded-running-bra-womens-high-support-sports-bra-plus-size-caesious-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_04b21f18-0b11-4f20-b034-baecf4f2b9f1.jpg",
        title: "Enfold Zip Front Padded Running Bra",
        a: "$19.99"
      }
    ]
  },
  "E110522B03AS_14P Red": {
    items: [
      {
        url: "/products/power-cross-back-padded-running-bra-rose",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bd5df51c-1318-4763-9501-b5e657989f99.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-rose",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_98c5cde1-76e0-4b01-bd87-d67133c6c560.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/sculpt-racerback-line-padded-running-bra-womens-high-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8f1c18b4-6d0b-4ce7-9115-e3971002b913.jpg",
        title: "Sculpt Racerback Line Padded Running Bra",
        a: "$34.99"
      },
      {
        url: "/products/sculpt-racerback-line-padded-running-bra-womens-high-support-sports-bra-plus-size-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_4f584831-1c02-4bff-96df-4af6833f874b.jpg",
        title: "Sculpt Racerback Line Padded Running Bra",
        a: "$34.99"
      }
    ]
  },
  "E100807A08_09A Black": {
    items: [
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-stretchy-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_b10247ea-92c6-4878-a1d5-808cb938c80b.jpg",
        title: "Power High Waist Mesh Pockets Stretchy Running Leggings",
        a: "$45.90"
      }
    ]
  },
  "E110428A01_09A Black": {
    items: [
      {
        url: "/products/anywhere-high-neck-padded-gym-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_93139dfb-97fb-4cd0-ac8d-76187cd2db34.jpg",
        title: "Anywhere High Neck Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      }
    ]
  },
  "E101030A06_26200 Gray": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E100719A19_36F Light Brown": {
    items: [
      {
        url: "/products/power-high-waist-lined-running-leggings-womens-high-support-leggings-dark-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_cf0698f9-0530-4ed1-9db3-2fa35f20f882.jpg",
        title: "Power High Waist Lined Running Leggings",
        a: "$32.00"
      },
      {
        url: "/products/women-high-waisted-perforated-running-leggings-35i-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_ccc833bd-97a4-4ba7-9c18-c438cc8339e7.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      }
    ]
  },
  "E110481A01_54Z Green": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4e60f411-44f3-4d0d-8ee7-88f20eebdb7d.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_fda426b8-2951-4a25-a382-ad6bd23cbe79.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_154cff11-c235-4e9f-a33b-791780cc36ca.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e38c17c4-32e4-4a86-b1ab-ec3b3f169767.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/power-adjustable-running-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112154.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      },
      {
        url: "/products/power-adjustable-padded-running-bra-womens-high-support-sports-bra-plus-size-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_d270aa11-f98a-4600-9438-d478d9f88838.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      }
    ]
  },
  "E110481A01_11AI Pink": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4e60f411-44f3-4d0d-8ee7-88f20eebdb7d.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_fda426b8-2951-4a25-a382-ad6bd23cbe79.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_154cff11-c235-4e9f-a33b-791780cc36ca.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e38c17c4-32e4-4a86-b1ab-ec3b3f169767.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/power-adjustable-running-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112154.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      },
      {
        url: "/products/power-adjustable-padded-running-bra-womens-high-support-sports-bra-plus-size-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_d270aa11-f98a-4600-9438-d478d9f88838.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      }
    ]
  },
  "E110481A01_09A Black": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4e60f411-44f3-4d0d-8ee7-88f20eebdb7d.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_fda426b8-2951-4a25-a382-ad6bd23cbe79.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_154cff11-c235-4e9f-a33b-791780cc36ca.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_e38c17c4-32e4-4a86-b1ab-ec3b3f169767.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/power-adjustable-running-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112154.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      },
      {
        url: "/products/power-adjustable-padded-running-bra-womens-high-support-sports-bra-plus-size-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_d270aa11-f98a-4600-9438-d478d9f88838.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      }
    ]
  },
  "E110479B21_09A Black Print": {
    items: [
      {
        url: "/products/power-print-zip-mesh-padded-running-bra-womens-high-support-sports-bra-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_c7f2b736-6b4a-4bf7-8501-936807c2d6c9.jpg",
        title: "Power Print Zip Mesh Padded Running Bra",
        a: "$19.00"
      },
      {
        url: "/products/power-print-zip-mesh-padded-running-bra-womens-high-support-sports-bra-light-yellow",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_b267d8e6-6bbb-4b26-8f4c-f4db63aeb19a.jpg",
        title: "Power Print Zip Mesh Padded Running Bra",
        a: "$19.00"
      },
      {
        url: "/products/power-print-zip-mesh-padded-running-bra-womens-high-support-sports-bra-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_f678f2d4-b201-4e0a-a5c0-d8b685e0e3d2.jpg",
        title: "Power Print Zip Mesh Padded Running Bra",
        a: "$19.00"
      }
    ]
  },
  "E110479B21_67U Blue Print": {
    items: [
      {
        url: "/products/power-print-zip-mesh-padded-running-bra-womens-high-support-sports-bra-sea-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_e1707f1e-64f0-4fff-b707-baba35bb14f8.jpg",
        title: "Power Print Zip Mesh Padded Running Bra",
        a: "$19.00"
      },
      {
        url: "/products/power-print-zip-mesh-padded-running-bra-womens-high-support-sports-bra-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_c7f2b736-6b4a-4bf7-8501-936807c2d6c9.jpg",
        title: "Power Print Zip Mesh Padded Running Bra",
        a: "$19.00"
      },
      {
        url: "/products/power-print-zip-mesh-padded-running-bra-womens-high-support-sports-bra-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_f678f2d4-b201-4e0a-a5c0-d8b685e0e3d2.jpg",
        title: "Power Print Zip Mesh Padded Running Bra",
        a: "$19.00"
      }
    ]
  },
  "E100771B21_09A Black Print": {
    items: [
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-blue-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/6_-2_3cc95bac-6125-4280-878b-f07595f24819.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      },
      {
        url: "/products/power-print-high-waist-biker-shorts-womens-high-support-sports-shorts-black-print",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_7db4f6b6-0d72-4c20-a7db-e13836859f5c.jpg",
        title: "Power Print High-Waist Biker Shorts 8",
        a: "$11.00"
      }
    ]
  },
  "E100770C21_64NMM Blue": {
    items: [
      {
        url: "/products/power-high-waist-mesh-pockets-stretchy-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_b10247ea-92c6-4878-a1d5-808cb938c80b.jpg",
        title: "Power High Waist Mesh Pockets Stretchy Running Leggings",
        a: "$45.90"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-stretchy-running-leggings-womens-high-support-leggings-58a-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_4dcd291e-7478-4b3d-9fd8-ec345428407e.jpg",
        title: "Power High Waist Mesh Pockets Stretchy Running Leggings",
        a: "$45.90"
      }
    ]
  },
  "E100770C21_58AMM Dark Green": {
    items: [
      {
        url: "/products/power-high-waist-mesh-pockets-stretchy-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_b10247ea-92c6-4878-a1d5-808cb938c80b.jpg",
        title: "Power High Waist Mesh Pockets Stretchy Running Leggings",
        a: "$45.90"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-stretchy-running-leggings-womens-high-support-leggings-58a-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_4dcd291e-7478-4b3d-9fd8-ec345428407e.jpg",
        title: "Power High Waist Mesh Pockets Stretchy Running Leggings",
        a: "$45.90"
      }
    ]
  },
  "E100538A21_16B Red": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "E100538A21_09A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  
  "E110353A21_05D Medium Grey": {
    items: [
      {
        url: "/products/power-zip-adjustable-straps-padded-running-bra-womens-high-support-sports-bra-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_874f521d-b122-424d-831b-36cb8b592258.jpg",
        title: "Power Zip Adjustable Straps Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-zip-adjustable-straps-padded-running-bra-womens-high-support-sports-bra-plus-size-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_e790a18b-ec06-4dbb-b11d-5855b55d3e94.jpg",
        title: "Power Zip Adjustable Straps Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/sculpt-racerback-line-padded-running-bra-womens-high-support-sports-bra-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f8b7547c-09b2-4000-925f-19463cc20761.jpg",
        title: "Sculpt Racerback Line Padded Running Bra",
        a: "$34.99"
      }
    ]
  },
  "E101030A06_09A Black": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$37.99"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E120384A03_00A White": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E120384A03_09A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E120278A03_00A White": {
    items: [
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E120379A03_56K Olive": {
    items: [
      {
        url: "/products/shift-high-waist-brushed-soft-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_d96abd40-661b-476a-a2a9-316b9887b8fc.jpg",
        title: "Shift High Waist Brushed Soft Yoga Leggings 25' 27",
        a: "$49.90"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "http://yvettesports.com/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E120379A03_67J Blue": {
    items: [
      {
        url: "/products/shift-high-waist-brushed-soft-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_d96abd40-661b-476a-a2a9-316b9887b8fc.jpg",
        title: "Shift High Waist Brushed Soft Yoga Leggings 25' 27",
        a: "$49.90"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "http://yvettesports.com/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E120367A01_60I Light Blue": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E120367A01_00A White": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/echo-stretchy-breathable-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_686fc9cd-b481-4619-a741-768c75ba80e9.jpg",
        title: "7/8 Sculpt Stretchy Fleece leggings 24",
        a: "$35.00"
      }
    ]
  },
  "E120279A03_70A Light Purple": {
    items: [
      {
        url: "/products/enfold-woven-two-in-one-running-shorts-womens-sports-shorts-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_8385301d-b521-4493-9eb9-e339ada8cbfd.jpg",
        title: "Enfold Woven Two In One Running Shorts",
        a: "$29.00"
      },
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      },
      {
        url: "/products/echo-high-waist-pockets-biker-shorts-womens-high-support-sports-shorts-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_c3732ddc-791b-4887-a511-ea74379a407b.jpg",
        title: "Echo High-Waist Butt Lifting Biker Shorts 9",
        a: "$27.00"
      }
    ]
  },
  "E150328A08_04G Grey": {
    items: [
      {
        url: "/products/shift-fleece-slim-fit-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_92db3082-c565-4b36-a1b7-7010a5448a93.jpg",
        title: "Shift Fleece Light Stretchy Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/shift-fleece-color-block-pockets-zip-jacket-womens-sports-jacket-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_076c183e-8e9a-49e8-bfd2-a519374c48f0.jpg",
        title: "Shift Fleece Color Block Pockets Zip Jacket",
        a: "$79.00"
      }
    ]
  },
  "E150328A08_09A Black": {
    items: [
      {
        url: "/products/shift-fleece-slim-fit-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_92db3082-c565-4b36-a1b7-7010a5448a93.jpg",
        title: "Shift Fleece Light Stretchy Full Zip Jacket",
        a: "$43.90"
      },
      {
        url: "/products/shift-fleece-color-block-pockets-zip-jacket-womens-sports-jacket-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_076c183e-8e9a-49e8-bfd2-a519374c48f0.jpg",
        title: "Shift Fleece Color Block Pockets Zip Jacket",
        a: "$79.00"
      }
    ]
  },
  "S120410A08_09A Black": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4e60f411-44f3-4d0d-8ee7-88f20eebdb7d.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_fda426b8-2951-4a25-a382-ad6bd23cbe79.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      }
    ]
  },
  "S120410A08_01A Off White": {
    items: [
      {
        url: "/products/power-v-neck-cross-back-padded-running-bra-womens-high-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9d57753c-c2ba-487d-9fbe-98d683d12afd.jpg",
        title: "Power V-Neck Cross Back Padded Running Bra",
        a: "$36.99"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "S120406A08_00A White": {
    items: [
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "S120406A08_56K Olive": {
    items: [
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "S120406A08_33F Khaki": {
    items: [
      {
        url: "/products/power-high-waist-lined-running-leggings-womens-high-support-leggings-dark-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_cf0698f9-0530-4ed1-9db3-2fa35f20f882.jpg",
        title: "Power High Waist Lined Running Leggings",
        a: "$32.00"
      },
      {
        url: "/products/echo-stretchy-butt-sculpting-biker-shorts-womens-high-support-biker-shorts-wine",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_8dadc5c5-bb6b-49de-a404-6cec41fd5990.jpg",
        title: "Anywhere Stretchy Butt-sculpting Biker Shorts 8",
        a: "$28.00"
      },
      {
        url: "/products/women-high-waisted-perforated-running-leggings-35i-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_ccc833bd-97a4-4ba7-9c18-c438cc8339e7.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      }
    ]
  },
  "E110347A03_09A Black": {
    items: [
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_4ce4e2ac-3889-45a8-b3a3-3eaf13691967.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$35.00"
      },
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-black-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2ada7996-4efa-4450-84fd-cf65f56c452b.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      }
    ]
  },
  "E110347A03_67J Blue": {
    items: [
      {
        url: "/products/anywhere-round-neckline-running-t-shirt-womens-sports-t-shirt-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_d6118ce3-192b-446e-8cb4-d23c69152e53.jpg",
        title: "Anywhere Round Neck Long Running T-shirt",
        a: "$29.00"
      },
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5cb5809a-19ec-499b-b134-2c285f5e86fe.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$35.00"
      }
    ]
  },
  "E110347A03_14M Red": {
    items: [
      {
        url: "/products/anywhere-high-neck-padded-gym-bra-womens-light-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_695de8ab-f363-4e12-a35b-efc16c7eaf26.jpg",
        title: "Anywhere High Neck Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/sculpt-racerback-line-padded-running-bra-womens-high-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8f1c18b4-6d0b-4ce7-9115-e3971002b913.jpg",
        title: "Sculpt Racerback Line Padded Running Bra",
        a: "$34.99"
      },
      {
        url: "/products/sculpt-racerback-line-padded-running-bra-womens-high-support-sports-bra-plus-size-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_4f584831-1c02-4bff-96df-4af6833f874b.jpg",
        title: "Sculpt Racerback Line Padded Running Bra",
        a: "$34.99"
      }
    ]
  },
  "S120454A06_63H Blue": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S120454A06_70A Light Purple": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "S120454A06_09A Black": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "H0800008_71C Blue Purple": {
    items: [
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/echo-stretchy-solid-capri-leggings-womens-high-support-capri-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a20f8515-b91c-4f61-85d2-19cf46e3c266.jpg",
        title: "Anywhere Stretchy Streamlined leggings 21",
        a: "$29.00"
      },
      {
        url: "/products/power-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bbe99ba-6a80-4591-bf94-f37ee2195099.jpg",
        title: "Power High Waist Mesh Pockets Running Leggings 26",
        a: "$37.99"
      }
    ]
  },
  "H0800008_10B Pink": {
    items: [
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$37.99"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "H0800008_50H Light Green": {
    items: [
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/women-high-waisted-perforated-running-leggings-54abgreen",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_5e8d55b1-3542-48f4-a1c1-72c37688795f.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "S100546A03_09A Black": {
    items: [
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "S100546A03_13F Red": {
    items: [
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_46cdb7d8-7b15-41f4-b4db-9697a6a52111.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E110350A08_09A Black": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bb705aa5-e1ed-486a-8f92-451520d54e3a.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_16e03740-ee96-4157-9dda-3624727b2ce4.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_870c73f7-925e-4b68-8a04-011afcd6aee3.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_ca5c79d0-22b6-436d-b8f7-7291d39ed4bd.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-womens-high-support-sports-bra-plus-size-olive",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_f1661869-14d8-42d5-aaae-bb56b3bc04ce.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bd99720-995d-4515-b0d5-e769fa9e912c.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_163f88f4-58c9-4e4f-a6ea-c0bf1d229f51.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      }
    ]
  },
  "E130135A03_53HM Green": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.99"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ad3b7033-8d4a-4d99-bf45-9677d8602f59.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      }
    ]
  },
  "S100477A08_35G Light Brown": {
    items: [
      {
        url: "/products/women-high-waisted-perforated-running-leggings-35i-light-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_ccc833bd-97a4-4ba7-9c18-c438cc8339e7.jpg",
        title: "Women High-Waisted Perforated Running Leggings",
        a: "$46.00"
      },
      {
        url: "/products/power-high-waist-lined-running-leggings-womens-high-support-leggings-dark-brown",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_cf0698f9-0530-4ed1-9db3-2fa35f20f882.jpg",
        title: "Power High Waist Lined Running Leggings",
        a: "$32.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "SN0010012_16B Red": {
    items: [
      {
        url: "/products/power-adjustable-running-bra-burgundy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112107.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      },
      {
        url: "/products/power-adjustable-padded-running-bra-womens-high-support-sports-bra-plus-size-burgundy",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_99d7e8d8-40e1-45dc-89a5-d5525d6216ae.jpg",
        title: "Power Adjustable Padded Running Bra",
        a: "$45.00"
      },
      {
        url: "/products/power-adjustable-straps-racerback-padded-running-bra-womens-high-support-sports-bra-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_e8d7ecf3-6b3e-4948-bd8c-e52ba4b112cd.jpg",
        title: "Power Adjustable Straps Racerback Padded Running Bra",
        a: "$38.99"
      },
      {
        url: "/products/power-adjustable-straps-racerback-padded-running-bra-womens-high-support-sports-bra-plus-size-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_c7427e28-970d-4ffa-bab8-c773c4ed9992.jpg",
        title: "Power Adjustable Straps Racerback Padded Running Bra",
        a: "$38.99"
      }
    ]
  },
  "SN0010012_59A Dark Green": {
    items: [
      {
        url: "/products/power-adjustable-enhance-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_143ddd75-b6c0-462d-a1d1-ffc793a0fe1e.jpg",
        title: "Power Adjustable Enhance Padded Running Bra",
        a: "$36.99"
      },
      {
        url: "/products/shift-racerback-mesh-padded-running-bra-womens-high-support-sports-bra-dark-grey-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_807d50f7-612f-4c9d-b55c-a3600d9ce5c0.jpg",
        title: "Shift V-neck Mesh Padded Running Bra",
        a: "$38.90"
      },
      {
        url: "/products/shift-racerback-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_6bfd96ca-be08-4fa9-b11f-a161121eafdc.jpg",
        title: "Shift V-neck Mesh Padded Running Bra",
        a: "$38.90"
      },
      {
        url: "/products/enfold-dark-grey-zip-front-racerback-padded-running-bra-womens-high-support-sports-bra",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_60b94061-5927-4258-bdf5-5014cdd907e5.jpg",
        title: "Enfold Zip Front Racerback Padded Running Bra",
        a: "$35.99"
      },
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-womens-high-support-sports-bra-plus-size-dark-grey-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_19612107-4a35-44d5-8e7b-accd557ad06b.jpg",
        title: "Enfold Zip Front Racerback Padded Running Bra",
        a: "$35.99"
      }
    ]
  },
  "SN0010012_67B Sea Blue": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-royal-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9b5ae16c-4851-463a-baa1-44eab5f7256d.jpg",
        title: "Power Adjustable Criss Cross Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-royal-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_a4bd1b5f-7905-4689-8575-28545debf341.jpg",
        title: "Power Adjustable Criss Cross Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-royal-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/202203016994.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-royalblue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_b762b0cd-6f0f-43a2-976f-78417de866eb.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      }
    ]
  },
  "SN0010012_Black": {
    items: [
      {
        url: "/products/echo-front-zip-modern-perforated-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_18b8e93d-31b8-40be-9cc9-a13e9dcfcd63.jpg",
        title: "Echo Front Zip Perforated Solid Padded Running Bra",
        a: "$34.99"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-09ablack",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/4_24afcd54-24f9-4daa-bd26-a9d761c26768.jpg",
        title: "Echo Hollow Out Breathable Padded Running Bra",
        a: "$39.90"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1bd99720-995d-4515-b0d5-e769fa9e912c.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_163f88f4-58c9-4e4f-a6ea-c0bf1d229f51.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      }
    ]
  },
  "E100710A06_13B Rose": {
    items: [
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-pink-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_f633d113-78a6-4d95-b758-847d8cd04b11.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E100710A06_00A White": {
    items: [
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "E100710A06_09A Black": {
    items: [
      {
        url: "/products/high-waist-sculpting-fitness-gym-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_2b23b894-0d23-46f0-9bc5-86431d6a9313.jpg",
        title: "High Waist Sculpting Fitness Gym Leggings 26",
        a: "$28.50"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "HM0080025_09PTAC Black Print": {
    items: [
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$31.99"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "S120361A01_05O Grey Melange": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-black-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1f0ec0b4-7ab5-4251-b471-1204b355b4c8.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "S120361A01_10AF Pink Melange": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-black-together",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_1f0ec0b4-7ab5-4251-b471-1204b355b4c8.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      }
    ]
  },
  "E100505A01_09A Black": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$37.99"
      }
    ]
  },
  "H0800008_Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      },
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "H0800008_08A Dark Grey": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$37.99"
      },
      {
        url: "/products/sculpt-high-waisted-airhole-running-leggings-womens-high-support-leggings-dark-green",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_934f984c-979f-4745-bdde-8826f8d90663.jpg",
        title: "Sculpt Breathable Airhole Running Leggings 22",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "H0800008_15A Burgundy": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-brushed-yoga-leggings-womens-light-support-sports-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_bf1076f4-af4a-4b5f-bfb8-d54757d0fc9c.jpg",
        title: "7/8 Shift High Waist Brushed Yoga Leggings 24",
        a: "$29.99"
      }
    ]
  },
  "S100335A03_72B Blue Purple": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100335A03_00A White": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100335A03_09A Black": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S100335A03_11M Pink": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "S110039A_76A Purple": {
    items: [
      {
        url: "/products/shift-scoop-neckline-double-straps-padded-yoga-bra-womens-light-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c4c55990-2a72-47e1-ba07-7430805530c4.jpg",
        title: "Shift Scoop Neckline Double Straps Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/shift-scoop-neckline-double-straps-padded-yoga-bra-womens-light-support-sports-bra-light-purple",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/3_a5184af9-ebbf-4707-9dd2-5092a118d9e1.jpg",
        title: "Shift Scoop Neckline Double Straps Padded Yoga Bra",
        a: "$28.00"
      }
    ]
  },
  "S110039A_09A Black": {
    items: [
      {
        url: "/products/shift-scoop-neckline-double-straps-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_382c9f68-538c-4806-a919-fd14fc7613b8.jpg",
        title: "Shift Scoop Neckline Double Straps Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/anywhere-high-neck-padded-gym-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_93139dfb-97fb-4cd0-ac8d-76187cd2db34.jpg",
        title: "Anywhere High Neck Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/shift-scoop-neckline-double-straps-padded-yoga-bra-womens-light-support-sports-bra-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c4c55990-2a72-47e1-ba07-7430805530c4.jpg",
        title: "Shift Scoop Neckline Double Straps Padded Yoga Bra",
        a: "$28.00"
      }
    ]
  },
  "S110192A02_65B Royal Blue": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-royal-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9b5ae16c-4851-463a-baa1-44eab5f7256d.jpg",
        title: "Power Adjustable Criss Cross Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-plus-size-royal-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_a4bd1b5f-7905-4689-8575-28545debf341.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-royal-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/202203016994.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      },
      {
        url: "/products/enfold-hollow-out-padded-running-bra-womens-high-support-sports-bra-plus-size-royalblue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/3_b762b0cd-6f0f-43a2-976f-78417de866eb.jpg",
        title: "Enfold Hollow out Padded Running Bra",
        a: "$33.00"
      }
    ]
  },
  "S110192A02_05D Medium Grey": {
    items: [
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_6e6cd817-07bb-4d34-8138-dd9b830222f1.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_87dd0978-a085-4877-add0-30f4fd22ccdb.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/enfold-zip-mesh-padded-running-bra-womens-high-support-sports-bra-plus-size-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/6_-1_95cd47b9-7f5a-4a16-9594-d427a0a56836.jpg",
        title: "Enfold Zip Mesh Padded Running Bra",
        a: "$35.00"
      },
      {
        url: "/products/power-adjustable-enhance-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_143ddd75-b6c0-462d-a1d1-ffc793a0fe1e.jpg",
        title: "Power Adjustable Enhance Padded Running Bra",
        a: "$36.99"
      }
    ]
  },
  "S110192A02_09A Black": {
    items: [
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-black-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2ada7996-4efa-4450-84fd-cf65f56c452b.jpg",
        title: "Anywhere Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/anywhere-high-neck-padded-gym-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_93139dfb-97fb-4cd0-ac8d-76187cd2db34.jpg",
        title: "Anywhere High Neck Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/echo-long-double-cross-straps-padded-yoga-bra-womens-light-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_4ce4e2ac-3889-45a8-b3a3-3eaf13691967.jpg",
        title: "Echo Long Double Cross Straps Padded Yoga Bra",
        a: "$35.00"
      }
    ]
  },
  "SU6015_Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "SU6015_Grey": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_b0a9136b-26e8-43f1-ad95-d3e81438df69.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-high-waist-tight-running-shorts-womens-high-support-sports-shorts-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_4988db8f-928a-46f9-9cb8-f18e056412ec.jpg",
        title: "Shift High-Waist Tight Running Shorts 3' 4' 6' 8",
        a: "$27.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-medium-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_be177957-da8b-4fa3-98b9-17a05dcc3f19.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/pockets-with-reflectives-tripe-high-waisted-running-leggings-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_0eb30eab-a681-4db6-9b0b-ff377bb30e00.jpg",
        title: "Pockets With Reflectives Tripe Running Leggings 26",
        a: "$37.99"
      },
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      }
    ]
  },
  "SU6015_00A White": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/shift-high-waist-brushed-soft-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_d96abd40-661b-476a-a2a9-316b9887b8fc.jpg",
        title: "Shift High Waist Brushed Soft Yoga Leggings 25' 27",
        a: "$49.90"
      },
      {
        url: "/products/enfold-high-waisted-butt-lifting-running-leggings-24-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/7_cebd092a-ded3-450f-96fa-67b91555276f.jpg",
        title: "Enfold High-Waisted Butt Lifting Running Leggings 24",
        a: "$32.90"
      }
    ]
  },
  "S100335A03_04C Smoky Grey": {
    items: [
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      },
      {
        url: "/products/echo-stretchy-tummy-control-full-length-leggings-womens-high-support-full-length-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_8c70632b-7e40-478b-8174-1f33e8f93f06.jpg",
        title: "7/8 Echo Stretchy Tummy Control leggings 24",
        a: "$35.00"
      }
    ]
  },
  "SU6015_Blue Tide": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      }
    ]
  },
  "HM0080025_09A00A Black": {
    items: [
      {
        url: "/products/power-high-waist-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_1166446c-9c2b-4900-9616-82b189aac442.jpg",
        title: "7/8 Power High Waist Running Leggings 24",
        a: "$39.00"
      },
      {
        url: "/products/echo-high-waisted-modern-running-leggings-womens-high-support-leggings-off-white",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_2e925748-f4f1-43b7-9906-8750c070c9bd.jpg",
        title: "Echo High-Waisted Print Running Leggings 26",
        a: "$31.99"
      }
    ]
  },
  "HM0080025_25E41A Orange": {
    items: [
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-orange-red",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_46cdb7d8-7b15-41f4-b4db-9697a6a52111.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      },
      {
        url: "/products/echo-high-waisted-running-leggings-womens-high-support-leggings-09a-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_9a56a4f6-7d29-4c2d-81db-f998ae0206d2.jpg",
        title: "Echo High-Waisted Running Leggings 26",
        a: "$36.99"
      }
    ]
  },
  "E101030A06_00A White": {
    items: [
      {
        url: "/products/enfold-high-waist-mesh-pockets-running-leggings-womens-high-support-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/4_5c9e99b3-014b-4bbe-805d-f251d5eca691.jpg",
        title: "Enfold High Waist Mesh Pockets Running Leggings 26",
        a: "$29.00"
      },
      {
        url: "/products/shift-mesh-yoga-leggings-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_5f4cc1b5-59c6-443e-8b52-334981b01218.jpg",
        title: "Shift Mesh Yoga Leggings 26",
        a: "$31.90"
      }
    ]
  },
  "E150262A08_09A Black": {
    items: [
      {
        url: "/products/shift-mock-neck-thumbhole-full-zip-jacket-blue",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_6635e8e0-0484-4e3c-a1de-06942eb2b18a.jpg",
        title: "Shift Abstract Pattern Full Zip Jacket",
        a: "$49.90"
      },
      {
        url: "/products/echo-front-zip-perforated-breathable-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_a456bf2b-58ab-4cab-a1e4-34ef95c6ce31.jpg",
        title: "Echo Front Zip Perforated Breathable Padded Running Bra",
        a: "$39.99"
      },
      {
        url: "/products/shift-fleece-water-resistant-stretchy-full-zip-jacket-womens-sports-jacket-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_ee9a726b-859d-465e-8add-2f4040746b1f.jpg",
        title: "Shift Fleece Water Resistant Stretchy Full Zip Jacket",
        a: "$46.90"
      }
    ]
  },
    
  "common": {
    items: [
      {
        url: "/products/power-adjustable-criss-cross-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/1_c9be1177-7200-4e53-9177-3a58dcbc2de4.jpg",
        title: "Power Adjustable Criss Cross Padded Running Bra",
        a: "$34.00"
      },
      {
        url: "/products/shift-scoop-neckline-strappy-padded-yoga-bra-womens-light-support-sports-bra-black-1",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_636251a9-7048-4728-84c3-aeea78ddc453.jpg",
        title: "Shift Scoop Neckline Strappy Padded Yoga Bra",
        a: "$28.00"
      },
      {
        url: "/products/enfold-zip-front-racerback-padded-running-bra-womens-high-support-sports-bra-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_6230617c-db48-4c5f-aa28-c5042907f2a3.jpg",
        title: "Enfold Zip Front Mesh Racerback Padded Running Bra",
        a: "$29.00"
      },
      {
        url: "/products/power-cross-racerback-running-bra-womens-high-support-sports-bra-1-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_131c7aca-2764-4f66-a533-7193cf75db84.jpg",
        title: "Power Cross Racerback Running Bra",
        a: "$34.00"
      },
      {
        url: "/products/sculpt-racerback-line-padded-running-bra-womens-high-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_f7a549c3-86e5-4547-a07e-a52a4a4856c2.jpg",
        title: "Sculpt Racerback Line Padded Running Bra",
        a: "$28.00"
      },
      {
        url: "/products/anywhere-high-neck-padded-gym-bra-womens-light-support-sports-bra-smoky-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_9c8c5c06-a6b9-4437-bc37-499e2e915fcf.jpg",
        title: "Anywhere High Neck Padded Gym Bra",
        a: "$29.00"
      },
      {
        url: "/products/sculpt-zip-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-dark-grey",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_e22889bb-106d-415e-b8ad-5d7c4c4e6a7d.jpg",
        title: "Sculpt Zip Mesh Racerback Padded Running Bra",
        a: "$36.00"
      },
      {
        url: "/products/sculpt-zip-mesh-racerback-padded-running-bra-womens-high-support-sports-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/files/2_97d88297-ecd9-4032-ab72-394ddf8d2e78.jpg",
        title: "Sculpt Zip Mesh Racerback Padded Running Bra",
        a: "$36.00"
      },
      {
        url: "/products/power-zip-front-mesh-padded-running-bra-womens-high-support-sports-bra-pink",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2_b3537371-b16b-4bf4-8b07-bc9b76d81fdb.jpg",
        title: "Power Zip Front Mesh Padded Running Bra",
        a: "$34.00"
      },
      {
        url: "/products/power-cross-back-padded-running-bra-black",
        imageUrl: "https://www.yvettesports.com/cdn/shop/products/2022033112339.jpg",
        title: "Power Cross Back Padded Running Bra",
        a: "$32.00"
      },
    ]
  }

};
